import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import formatDateAndTime from "../../common/formatDateAndTime";
import getactions from "../../common/getactions";
import Commonmodal from "../../common/Commonmodal";
import RefundChecklistModal from "../../common/RefundChecklistModal";

const Bookinglineitems = ({
  bookingId,
  costToCustomer,
  totalAmountPaid,
  summaryDetails,
  setOpenTab,
  getAllBookings,
  transactionDetails,
  getBookingDetail,
  setActiveTab,
  systemUserData,
  paymentDetailsData,
}) => {
  const profile = JSON.parse(localStorage.getItem("profile"));
  let bookingCharges = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.bookingCharges;
  let catalogId = JSON.parse(
    localStorage.getItem("catalogMaster"),
  )?.bookingCharges;
  let refundCatalogId = JSON.parse(
    localStorage.getItem("catalogMaster"),
  )?.bookingRefunds;
  let bookingRefunds = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.bookingRefunds;
  let token = localStorage.getItem("token");
  delete bookingCharges?.inverted;
  delete bookingRefunds?.inverted;
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const refundStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.refundStatus;
  const fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;
  const actionsToAccess = getactions(profile?.roles, profile?.actions);

  const [isChecklistModalOpen, setIsChecklistModalOpen] = useState(false);
  const [bookingComments, setBookingComments] = useState([]);
  const [fleetBookingComments, setFleetBookingComments] = useState([]);

  const [filterType, setFilterType] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [fleetbookinglineitems, setFleetBookingLineItems] = useState([]);
  const [fleetbookingRefundLineItems, setFleetBookingRefundLineItems] =
    useState([]);

  const [inputChargeDatas, setInputChargeDatas] = useState({
    chargeType: null,
    amount: null,
    quantity: null,
    description: "",
  });
  const [inputRefundDatas, setRefundDatas] = useState({
    refundType: null,
    amount: null,
    quantity: null,
    description: "",
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [refundFile, setRefundFile] = useState(null);
  const [openImage, setOpenImage] = useState(false);
  const [imageSelection, setImageSelection] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [submittingCharge, setSubmittingCharge] = useState(false);
  const [submittingRefund, setSubmittingRefund] = useState(false);
  const [submittingInitiation, setSubmittingInitiation] = useState(false);

  const handleImageClose = () => {
    setImageSelection(null);
    setOpenImage(false);
  };

  const handleImageOpen = (url) => {
    setImageSelection(url);
    setOpenImage(true);
  };

  const handleFileChange = async (event, type) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("entityName", "pettyCash");
    formData.append("fileTags", "vehicle");
    formData.append("files", file);

    if (type === "Charge") {
      setUploading(true);
    } else {
      setUploading(true);
    }
    try {
      const response = await fetch(`${apiUrl}/fileapi/upload`, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data) {
        if (type === "Charge") {
          setUploading(false);
          setSelectedFile(data?.uploaded);
        } else {
          setUploading(false);
          setRefundFile(data?.uploaded);
        }
      }
      // ✅ reset so same file can be re-selected later
      event.target.value = null;

      return data;
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const [chargesLineItems, setChargesLineItems] = useState(null);
  const [refundLineItems, setRefundLineItems] = useState(null);

  const getfleetbookinglineitems = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/fleetbookinglineitems?bookingId=${bookingId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        const rows = data?.entities?.rows ?? [];

        const chargesLineItemsType = rows
          .filter((item) => item.lineItemType === 63)
          .map((item) => ({
            typeText: bookingCharges[item?.lineItemSubType] ?? "Unknown Charge",
            amount: item.amount,
            comments: item.comments,
          }));

        const refundLineItemsType = rows
          .filter((item) => item.lineItemType === 64)
          .map((item) => ({
            typeText: bookingRefunds[item?.lineItemSubType] ?? "Unknown Refund",
            amount: item.amount,
            comments: item.comments,
          }));

        setChargesLineItems(chargesLineItemsType);
        setRefundLineItems(refundLineItemsType);

        const chargeDatas = data?.entities?.rows.filter(
          (item) => item?.lineItemType === Number(catalogId),
        );
        const refundDatas = data?.entities?.rows.filter(
          (item) => item?.lineItemType === Number(refundCatalogId),
        );
        setFleetBookingLineItems(chargeDatas);
        setFleetBookingRefundLineItems(refundDatas);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  useEffect(() => {
    if (bookingId) {
      getfleetbookinglineitems();
    }
  }, [bookingId]);

  const getBookingComments = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/bookingcomments?limit=1000&bookingId=${id}`,
        { method: "GET" },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        const sorted = data?.entities?.rows.sort(
          (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
        );
        setBookingComments(sorted);
      }
      return data;
    } catch (error) {
      console.error("Error fetching booking comments:", error);
    }
  };

  useEffect(() => {
    if (bookingId) {
      getBookingComments(bookingId);
    }
  }, [bookingId]);

  const filteredTransactions = fleetbookinglineitems.filter((txn) => {
    const matchType = filterType ? txn.type === filterType : true;
    const matchStatus = filterStatus ? txn.status === filterStatus : true;
    return matchType && matchStatus;
  });

  const filteredRefundTransactions = fleetbookingRefundLineItems.filter(
    (txn) => {
      const matchType = filterType ? txn.type === filterType : true;
      const matchStatus = filterStatus ? txn.status === filterStatus : true;
      return matchType && matchStatus;
    },
  );

  const handleInitiateRefund = async (refundableAmountData) => {
    try {
      const refundBreakupList = [
        {
          typeText: "Security Deposit",
          amount: summaryDetails?.securityDeposit,
        },
        ...chargesLineItems,
        ...refundLineItems,
      ];

      setSubmittingInitiation(true);

      const response = await fetch(`${apiUrl}/api/bookingrefunds`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          bookingId: summaryDetails?.id,
          refundStatus: refundStatus?.inverted?.pending,
          bookingCode: summaryDetails?.bookingCode,
          refundableAmount: Number(refundableAmountData.toFixed(2)),
          customerName: summaryDetails?.customerName,
          customerMobile: summaryDetails?.customerMobile,
          customerEmail: summaryDetails?.customerEmail,
          bookingEndDate: summaryDetails?.bookTo,
          bookingType : summaryDetails?.bookingType,
          bookingObject: {
            id: summaryDetails?.id,
            bookingStatus: fleetBookingStatus?.inverted?.refundPending,
            refundableAmount: Number(refundableAmountData.toFixed(2)),
          },
          refundBreakupList,
        }),
      });

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setOpenTab(false);
        getAllBookings();
        const chargeDatas = data?.entities?.rows.filter(
          (item) => item?.lineItemType === Number(catalogId),
        );
        const refundDatas = data?.entities?.rows.filter(
          (item) => item?.lineItemType === Number(refundCatalogId),
        );
        setFleetBookingLineItems(chargeDatas);
        setFleetBookingRefundLineItems(refundDatas);
        setSubmittingInitiation(false);
      } else {
        setOpenTab(false);
        getAllBookings();
        setSubmittingInitiation(false);
      }

      return data;
    } catch (error) {
      console.error("Error fetching Hub Names:", error);
      return setSubmittingInitiation(false);
    }
  };

  const resetForm = async () => {
    setInputChargeDatas({
      chargeType: null,
      amount: null,
      quantity: null,
      description: "",
    });
    setRefundDatas({
      refundType: null,
      amount: null,
      quantity: null,
      description: "",
    });
    setSelectedFile(null);
    setRefundFile(null);
  };

  const handleAdd = async (e, type) => {
    e.preventDefault();

    if (type === "Charge") {
      if (submittingCharge) return;
    } else if (submittingRefund) {
      return;
    }

    // Validation
    if (type === "Charge" && !selectedFile) {
      return toast.error("Please upload an image for the charge.");
    }
    if (type === "Refund" && !refundFile) {
      return toast.error("Please upload an image for the refund.");
    }

    if (inputChargeDatas.chargeType && inputRefundDatas.refundType) {
      toast.error("Submit only one: either Charge or Refund");
      await resetForm();
      return;
    }

    let body;
    if (type === "Charge") {
      body = {
        bookingId,
        lineItemSubType: inputChargeDatas?.chargeType,
        lineItemType: catalogId,
        amount: Number(inputChargeDatas?.amount),
        unitValue: inputChargeDatas?.quantity,
        comments: inputChargeDatas?.description,
        bookingObject: {
          id: bookingId,
          costToCustomer: summaryDetails?.costToCustomer,
        },
        imageUrl: selectedFile?.[0]?.url || null,
      };
    } else {
      body = {
        bookingId,
        lineItemSubType: inputRefundDatas?.refundType,
        lineItemType: refundCatalogId,
        amount: Number(inputRefundDatas?.amount),
        unitValue: inputRefundDatas?.quantity,
        comments: inputRefundDatas?.description,
        bookingObject: {
          id: bookingId,
          costToCustomer: summaryDetails?.costToCustomer,
        },
        imageUrl: refundFile?.[0]?.url || null,
      };
    }
    if (type === "Charge") {
      setSubmittingCharge(true);
    } else {
      setSubmittingRefund(true);
    }

    try {
      const response = await fetch(`${apiUrl}/api/fleetbookinglineitems`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(body),
      });
      const data = await response.json();

      if (data?.statusCode === "0100") {
        toast.success(`${type} added successfully! ✅`);

        // 🔄 Refresh UI data
        await getfleetbookinglineitems();
        await getBookingDetail(summaryDetails?.inquiryCode, "inquiry");

        // ♻️ Reset both forms completely
        resetForm();
      }
      return data;
    } catch (error) {
      toast.error("Request timed out. Please try again.");
      return console.error("Error fetching add charge:", error);
    } finally {
      setSubmittingCharge(false);
      setSubmittingRefund(false);
    }
  };

  useEffect(() => {
    if (chargesLineItems || refundLineItems) {
      calculateBookingRefundsPostCall();
    }
  }, [chargesLineItems, refundLineItems]);

  useEffect(() => {
    calculateBookingRefundsPostCall();
  }, [summaryDetails]);

  const [refundDetails, setRefundDetails] = useState(null);

  const calculateBookingRefundsPostCall = async () => {
    let body = {
      bookingInfo: {
        id: summaryDetails?.id,
        bookingUuid: summaryDetails?.bookingUuid,
        bookFrom: summaryDetails?.bookFrom,
        bookTo: summaryDetails?.bookTo,
        vehicleId: summaryDetails?.vehicleId,
        vehicleRegistrationNo: summaryDetails?.vehicleRegistrationNo,
        vehicleName: summaryDetails?.vehicleName,
        customerName: summaryDetails?.customerName,
        customerMobile: summaryDetails?.customerMobile,
        customerEmail: summaryDetails?.customerEmail,
        bookingStatus: summaryDetails?.bookingStatus,
        packageId: summaryDetails?.packageId,
        cityId: summaryDetails?.cityId,
        source: summaryDetails?.source,
        costToCustomer: summaryDetails?.costToCustomer,
        createdBy: summaryDetails?.createdBy,
        createdAt: summaryDetails?.createdAt,
        updatedBy: summaryDetails?.updatedBy,
        updatedAt: summaryDetails?.updatedAt,
        weekdayRent: summaryDetails?.weekdayRent,
        weekendRent: summaryDetails?.weekendRent,
        bookingHrs: summaryDetails?.bookingHrs,
        deliveryCharges: summaryDetails?.deliveryCharges,
        deliveryHubId: summaryDetails?.deliveryHubId,
        pickupHubId: summaryDetails?.pickupHubId,
        pickupCharges: summaryDetails?.pickupCharges,
        deliveryAddress: summaryDetails?.deliveryAddress,
        pickupAddress: summaryDetails?.pickupAddress,
        taxAmount: summaryDetails?.taxAmount,
        discountAmount: summaryDetails?.discountAmount,
        discountPercentage: summaryDetails?.discountPercentage,
        bookingCode: summaryDetails?.bookingCode,
        inquiryCode: summaryDetails?.inquiryCode,
        securityDeposit: summaryDetails?.securityDeposit,
        customerId: summaryDetails?.customerId,
        vehicleGroupId: summaryDetails?.vehicleGroupId,
        weekdayHrs: summaryDetails?.weekdayHrs,
        weekendHrs: summaryDetails?.weekendHrs,
        overallFreeKm: summaryDetails?.overallFreeKm,
        isDeliveryAgentAssigned: summaryDetails?.isDeliveryAgentAssigned,
        isPickupAgentAssigned: summaryDetails?.isPickupAgentAssigned,
        extraHrCharges: summaryDetails?.extraHrCharges,
        extraKmCharges: summaryDetails?.extraKmCharges,
        extraKms: summaryDetails?.extraKms,
        extraHrs: summaryDetails?.extraHrs,
        refundableAmount: summaryDetails?.refundableAmount,
        destination: summaryDetails?.destination,
        deliveryType: summaryDetails?.deliveryType,
        pickupType: summaryDetails?.pickupType,
        actualTripStart: summaryDetails?.actualTripStart,
        actualTripEnd: summaryDetails?.actualTripEnd,
        comment: summaryDetails?.comment,
        totalNoOfDays: summaryDetails?.totalNoOfDays,
        totalDistance: summaryDetails?.totalDistance,
        hubId: summaryDetails?.hubId,
        bookingType: summaryDetails?.bookingType,
        isTestData: summaryDetails?.isTestData,
        deliveryTypeInt: summaryDetails?.deliveryTypeInt,
        pickupTypeInt: summaryDetails?.pickupTypeInt,
      },
      paymentHistoryList: transactionDetails,
      bookingRefundList: refundLineItems,
      bookingChargesList: chargesLineItems,
    };

    try {
      const response = await fetch(
        `${apiUrl}/api/bookingrefunds/calculaterefundamount`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(body),
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setRefundDetails(data?.entities);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching add charge:", error);
    }
  };
  const cost = Number(costToCustomer);
  const paid = Number(totalAmountPaid);
  const pending = cost - paid;

  const fastagKeys = Object.keys(bookingCharges || {}).filter((k) =>
    bookingCharges[k]?.toLowerCase().includes("fastag"),
  );
  const fuelKeys = Object.keys(bookingCharges || {}).filter((k) =>
    bookingCharges[k]?.toLowerCase().includes("fuel"),
  );
  const trafficKeys = ["401"];
  const damageKeys = ["399"];

  // -----------------------------------
  const handledKeys = [
    ...fastagKeys,
    ...fuelKeys,
    ...trafficKeys,
    ...damageKeys,
    "435",
    "436",
  ];
  const otherCharges =
    fleetbookinglineitems
      ?.filter((item) => !handledKeys.includes(String(item.lineItemSubType)))
      .map((item) => ({
        ...item,
        chargeName: bookingCharges[item.lineItemSubType] || "Other Charge",
      })) || [];
  // -----------------------------------

  const chargeGroups = {
    fastag:
      fleetbookinglineitems?.filter((item) =>
        fastagKeys.includes(String(item.lineItemSubType)),
      ) || [],
    fuel:
      fleetbookinglineitems?.filter((item) =>
        fuelKeys.includes(String(item.lineItemSubType)),
      ) || [],
    traffic:
      fleetbookinglineitems?.filter((item) =>
        trafficKeys.includes(String(item.lineItemSubType)),
      ) || [],
    damage:
      fleetbookinglineitems?.filter((item) =>
        damageKeys.includes(String(item.lineItemSubType)),
      ) || [],
    others: otherCharges,
    extra: {
      extraKms: summaryDetails?.extraKms || 0,
      extraKmCharges: summaryDetails?.extraKmCharges || 0,
      extraHrs: summaryDetails?.extraHrs || 0,
      extraHrCharges: summaryDetails?.extraHrCharges || 0,
    },
  };

  const derivedChecks = [
    // {
    //   id: "recovery",
    //   label: "No pending recovery verified",
    //   isChecked: pending <= 0, 
    // },
    {
      id: "calculated",
      label: "Refundable amount calculated properly",
      isChecked: refundDetails?.refundableAmount !== undefined && refundDetails?.refundableAmount !== null,
    },
    {
    id: "fullypaid",
    label: "Customer has fully paid the booking amount",
    isChecked: pending <= 0,
  }
  ];

  const manualChecks = [
    { id: "inspected", label: "Vehicle inspected upon return" },
    { id: "nodamage", label: "No unbilled damage reported" },
    { id: "depositverified", label: "Deposit/petty cash photos verified" },
    { id: "customerack", label: "Customer acknowledgement obtained" },
    { id: "fuelverified", label: "Fuel level verified" },
    { id: "repairbills", label: "Repair bills reviewed" },
    { id: "traffic", label: "Traffic violations reviewed" },
    { id: "damage", label: "Damage charges reviewed" },
  ];

  return (
    <>
      <RefundChecklistModal
        open={isChecklistModalOpen}
        onClose={() => setIsChecklistModalOpen(false)}
        onConfirm={() => {
          setIsChecklistModalOpen(false);
          handleInitiateRefund(refundDetails?.refundableAmount);
        }}
        bookingId={summaryDetails?.id}
        bookingCode={summaryDetails?.bookingCode}
        costToCustomer={costToCustomer}
        totalAmountPaid={totalAmountPaid}
        chargeGroups={chargeGroups}
        manualChecks={manualChecks}
        derivedChecks={derivedChecks}
        bookingComments={bookingComments}
        fleetBookingComments={fleetBookingComments}
        readOnly={
          Number(fleetBookingStatus?.inverted?.refundPending) ===
            Number(summaryDetails?.bookingStatus) ||
          Number(fleetBookingStatus?.inverted?.bookingClosed) ===
            Number(summaryDetails?.bookingStatus)
        }
      />

      {openImage && (
        <Commonmodal
          open={openImage}
          onClose={handleImageClose}
          url={imageSelection}
        />
      )}
      <div>
        <div className="md:px-6 py-6 bg-white rounded-xl shadow-md">
          <h2 className="text-2xl font-bold text-gray-800 mb-8">
            Booking Line Items
          </h2>

          {String(fleetBookingStatus?.inverted?.refundPending) !==
            String(summaryDetails?.bookingStatus) &&
            String(fleetBookingStatus?.inverted?.bookingClosed) !==
              String(summaryDetails?.bookingStatus) && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                {/* Add Charge Form */}
                {actionsToAccess?.includes("Add Booking Charges Lineitems") && (
                  <div className="bg-gray-100 md:p-6 rounded-xl border-l-4 border-blue-500 shadow">
                    <h3 className="text-xl font-semibold text-gray-800 mb-6 flex items-center gap-2">
                      Add New Charge{" "}
                      <small className="text-xs text-gray">( Debit )</small>
                    </h3>
                    <form id="chargeForm" className="space-y-5">
                      <div>
                        <label
                          htmlFor="chargeType"
                          className="block font-medium text-gray-700 mb-1"
                        >
                          Charge Type
                        </label>
                        <select
                          id="chargeType"
                          required
                          value={inputChargeDatas.chargeType || ""}
                          onChange={(e) => {
                            setInputChargeDatas((prev) => ({
                              ...prev,
                              chargeType: e.target.value,
                            }));
                          }}
                          className="w-full border-2 border-gray-200 rounded-lg p-3 focus:ring focus:ring-blue-100"
                        >
                          <option value="">Select charge type</option>
                          {Object.entries(bookingCharges)?.map(
                            ([key, value], index) => {
                              return (
                                <option key={index} value={key}>
                                  {value}
                                </option>
                              );
                            },
                          )}
                        </select>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                          <label
                            htmlFor="chargeAmount"
                            className="block font-medium text-gray-700 mb-1"
                          >
                            Amount (₹)
                          </label>
                          <input
                            type="number"
                            id="chargeAmount"
                            min="0"
                            step="0.01"
                            required
                            value={inputChargeDatas.amount || ""}
                            onChange={(e) => {
                              setInputChargeDatas((prev) => ({
                                ...prev,
                                amount: e.target.value,
                              }));
                            }}
                            className="w-full border-2 border-gray-200 rounded-lg p-3 focus:ring focus:ring-blue-100"
                          />
                        </div>
                        <div>
                          <label
                            htmlFor="chargeQuantity"
                            className="block font-medium text-gray-700 mb-1"
                          >
                            Unit Value/Day/Count
                          </label>
                          <input
                            type="number"
                            id="chargeQuantity"
                            min="1"
                            value={inputChargeDatas.quantity || ""}
                            onChange={(e) => {
                              setInputChargeDatas((prev) => ({
                                ...prev,
                                quantity: e.target.value,
                              }));
                            }}
                            defaultValue={1}
                            className="w-full border-2 border-gray-200 rounded-lg p-3 focus:ring focus:ring-blue-100"
                          />
                        </div>
                      </div>

                      <div>
                        <label
                          htmlFor="chargeDescription"
                          className="block font-medium text-gray-700 mb-1"
                        >
                          Description
                        </label>
                        <textarea
                          style={{ resize: "none" }}
                          id="chargeDescription"
                          required
                          value={inputChargeDatas.description || ""}
                          onChange={(e) => {
                            setInputChargeDatas((prev) => ({
                              ...prev,
                              description: e.target.value,
                            }));
                          }}
                          placeholder="Enter detailed description of the charge..."
                          className="w-full border-2 border-gray-200 rounded-lg p-3 min-h-[80px] resize-y focus:ring focus:ring-blue-100"
                        ></textarea>
                      </div>

                      <div className="w-[400px] h-[200px] p-2 rounded-[10px] shadow-[4px_4px_30px_rgba(0,0,0,0.2)] flex flex-col justify-between items-center gap-1 bg-[rgba(0,110,255,0.041)]">
                        {/* Header */}
                        <div className="flex-1 w-full flex flex-col items-center justify-center border-2 border-dashed border-[royalblue] rounded-[10px] text-black text-center">
                          {uploading ? (
                            <div className="flex flex-col items-center justify-center gap-2">
                              <svg
                                className="animate-spin h-10 w-10 text-blue-600"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                />
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8v8z"
                                />
                              </svg>
                              <p className="text-blue-600 font-semibold">
                                Uploading...
                              </p>
                            </div>
                          ) : !selectedFile ? (
                            <>
                              <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                className="h-[100px]"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7 10V9C7 6.23858 9.23858 4 12 4C14.7614 4 17 6.23858 17 9V10C19.2091 10 21 11.7909 21 14C21 15.4806 20.1956 16.8084 19 17.5M7 10C4.79086 10 3 11.7909 3 14C3 15.4806 3.8044 16.8084 5 17.5M7 10C7.43285 10 7.84965 10.0688 8.24006 10.1959M12 12V21M12 12L15 15M12 12L9 15"
                                  stroke="#000000"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                              <p>Browse File to upload! and See Preview</p>
                            </>
                          ) : (
                            <img
                              alt="image"
                              className="h-40"
                              src={selectedFile[0]?.url}
                            />
                          )}
                        </div>

                        <label
                          htmlFor="file"
                          className="w-full h-10 px-2 rounded-[10px] bg-[rgba(0,110,255,0.075)] cursor-pointer flex items-center justify-end gap-2 text-black border-none"
                        >
                          Upload Image
                        </label>

                        <input
                          id="file"
                          type="file"
                          onChange={(event) => {
                            handleFileChange(event, "Charge");
                          }}
                          className="hidden"
                        />
                      </div>

                      <button
                        type="button"
                        onClick={(e) => handleAdd(e, "Charge")}
                        disabled={submittingCharge}
                        className={`w-full bg-gradient-to-r from-blue-500 to-blue-700 text-white font-semibold py-3 rounded-lg transition-all uppercase tracking-wide ${
                          submittingCharge
                            ? "opacity-70 cursor-not-allowed"
                            : "hover:shadow-md"
                        }`}
                      >
                        {submittingCharge ? "Submitting..." : "Add Charge"}
                      </button>
                    </form>
                  </div>
                )}

                {actionsToAccess?.includes("Add Booking Refunds Lineitems") && (
                  <div className="bg-gray-100 md:p-6 rounded-xl border-l-4 border-green-600 shadow">
                    <h3 className="text-xl font-semibold text-gray-800 mb-6 flex items-center gap-2">
                      Add Refund{" "}
                      <small className="text-xs text-gray">( Credit )</small>
                    </h3>
                    <form id="refundForm" className="space-y-5">
                      <div>
                        <label
                          htmlFor="refundType"
                          className="block font-medium text-gray-700 mb-1"
                        >
                          Refund Type
                        </label>
                        <select
                          id="refundType"
                          required
                          value={inputRefundDatas.refundType || ""}
                          onChange={(e) => {
                            setRefundDatas((prev) => ({
                              ...prev,
                              refundType: e.target.value,
                            }));
                          }}
                          className="w-full border-2 border-gray-200 rounded-lg p-3 focus:ring focus:ring-green-100"
                        >
                          <option value="">Select refund type</option>
                          {Object.entries(bookingRefunds)?.map(
                            ([key, value], index) => {
                              return (
                                <option key={index} value={key}>
                                  {value}
                                </option>
                              );
                            },
                          )}
                        </select>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                          <label
                            htmlFor="refundAmount"
                            className="block font-medium text-gray-700 mb-1"
                          >
                            Amount (₹)
                          </label>
                          <input
                            type="number"
                            id="refundAmount"
                            min="0"
                            step="0.01"
                            value={inputRefundDatas.amount || ""}
                            onChange={(e) => {
                              setRefundDatas((prev) => ({
                                ...prev,
                                amount: e.target.value,
                              }));
                            }}
                            required
                            className="w-full border-2 border-gray-200 rounded-lg p-3 focus:ring focus:ring-green-100"
                          />
                        </div>
                        <div>
                          <label
                            htmlFor="chargeQuantity"
                            className="block font-medium text-gray-700 mb-1"
                          >
                            Unit Value/Day/Count
                          </label>
                          <input
                            type="number"
                            id="chargeQuantity"
                            min="1"
                            value={inputRefundDatas.quantity || ""}
                            onChange={(e) => {
                              setRefundDatas((prev) => ({
                                ...prev,
                                quantity: e.target.value, // ✅ Correct key
                              }));
                            }}
                            defaultValue={1}
                            className="w-full border-2 border-gray-200 rounded-lg p-3 focus:ring focus:ring-blue-100"
                          />
                        </div>
                      </div>

                      <div>
                        <label
                          htmlFor="refundReason"
                          className="block font-medium text-gray-700 mb-1"
                        >
                          Reason for Refund
                        </label>
                        <textarea
                          id="refundReason"
                          style={{ resize: "none" }}
                          required
                          value={inputRefundDatas.description || ""}
                          onChange={(e) => {
                            setRefundDatas((prev) => ({
                              ...prev,
                              description: e.target.value,
                            }));
                          }}
                          placeholder="Enter detailed reason for the refund..."
                          className="w-full border-2 border-gray-200 rounded-lg p-3 min-h-[80px] resize-y focus:ring focus:ring-green-100"
                        ></textarea>
                      </div>

                      <div className="w-[400px] h-[200px] p-2 rounded-[10px] shadow-[4px_4px_30px_rgba(0,0,0,0.2)] flex flex-col justify-between items-center gap-1 bg-[rgba(0,110,255,0.041)]">
                        {/* Header */}
                        <div className="flex-1 w-full flex flex-col items-center justify-center border-2 border-dashed border-[royalblue] rounded-[10px] text-black text-center">
                          {uploading ? (
                            // ✅ Show spinner while refund image is uploading
                            <div className="flex flex-col items-center justify-center gap-2">
                              <svg
                                className="animate-spin h-10 w-10 text-green-600"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                />
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8v8z"
                                />
                              </svg>
                              <p className="text-green-600 font-semibold">
                                Uploading...
                              </p>
                            </div>
                          ) : !refundFile ? (
                            // ✅ Default state (no file chosen yet)
                            <>
                              <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                className="h-[100px]"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7 10V9C7 6.23858 9.23858 4 12 4C14.7614 4 17 6.23858 17 9V10C19.2091 10 21 11.7909 21 14C21 15.4806 20.1956 16.8084 19 17.5M7 10C4.79086 10 3 11.7909 3 14C3 15.4806 3.8044 16.8084 5 17.5M7 10C7.43285 10 7.84965 10.0688 8.24006 10.1959M12 12V21M12 12L15 15M12 12L9 15"
                                  stroke="#000000"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                              <p>Browse File to upload! and See Preview</p>
                            </>
                          ) : (
                            // ✅ After upload, show preview
                            <img
                              className="h-40 object-cover"
                              src={refundFile[0]?.url}
                              alt="image"
                            />
                          )}
                        </div>

                        {/* Footer / File input label */}
                        <label
                          htmlFor="refundfile"
                          className="w-full h-10 px-2 rounded-[10px] bg-[rgba(0,110,255,0.075)] cursor-pointer flex items-center justify-end gap-2 text-black border-none"
                        >
                          Upload Image
                        </label>

                        {/* Hidden file input */}
                        <input
                          id="refundfile"
                          type="file"
                          onChange={(event) => {
                            handleFileChange(event, "Refund");
                          }}
                          className="hidden"
                        />
                      </div>

                      <button
                        type="button"
                        onClick={(e) => handleAdd(e, "Refund")}
                        disabled={submittingRefund}
                        className={`w-full bg-gradient-to-r from-green-600 to-green-700 text-white font-semibold py-3 rounded-lg transition-all uppercase tracking-wide ${
                          submittingRefund
                            ? "opacity-70 cursor-not-allowed"
                            : "hover:shadow-md"
                        }`}
                      >
                        {submittingRefund ? "Submitting..." : "Add Refund"}
                      </button>
                    </form>
                  </div>
                )}
              </div>
            )}

          <div className="section mt-10">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2 border-b-4 pb-2 border-blue-500">
              Charges History
            </h2>

            <div className="overflow-auto rounded-lg shadow bg-white">
              <table className="min-w-full text-sm text-left">
                <thead className="bg-gray-200 text-black border border-2 shadow-lg">
                  <tr>
                    <th className="p-4">S.No</th>
                    <th className="p-4">Comments</th>
                    <th className="p-4">Type</th>
                    <th className="p-4">Added at</th>
                    <th className="p-4">Image</th>
                    <th className="p-4">Attachments</th>
                    <th className="p-4">Unit/Days/Count</th>
                    <th className="p-4 text-right">Amount</th>
                    <th className="p-4 text-right">Created by</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredTransactions?.map((txn) => (
                    <tr key={txn?.id} className="border-b hover:bg-gray-50">
                      <td className="p-4">
                        {txn?.id}
                        <br />
                      </td>
                      <td className="p-4">
                        <span>{txn?.comments || "-"}</span>
                      </td>
                      <td className="p-4">
                        {bookingCharges[txn?.lineItemSubType]}
                        <br />
                      </td>
                      <td
                        className={`p-4 text-center font-semibold ${
                          txn.type === "charge"
                            ? "text-red-500"
                            : "text-green-600"
                        }`}
                      >
                        {formatDateAndTime(txn?.updatedAt)}
                      </td>
                      <td className="p-4">
                        {txn?.imageUrl ? (
                          <img
                            onClick={() => {
                              handleImageOpen(txn?.imageUrl);
                            }}
                            className="h-10 w-10 cursor-pointer"
                            alt="No Image"
                            src={txn?.imageUrl || "N/A"}
                          />
                        ) : (
                          <>
                            <div>No Image</div>
                          </>
                        )}
                      </td>
                      <td className="p-4">
                        <div className="grid grid-cols-4 gap-1">
                          {txn?.attachments ? (
                            JSON.parse(txn.attachments)?.map((item, index) => (
                              <img
                                key={index}
                                onClick={() => handleImageOpen(item?.url)}
                                className="h-6 w-6 my-0.5 cursor-pointer"
                                alt={item?.fileName || "No Image"}
                                src={item?.url}
                              />
                            ))
                          ) : (
                            <>
                              <div>No Image</div>
                            </>
                          )}
                        </div>
                      </td>
                      <td className="p-4">
                        {txn?.unitValue}
                        <br />
                      </td>
                      <td className="p-4">{txn?.amount}</td>
                      <td className="p-4">
                        {systemUserData?.find(
                          (item) => txn?.createdBy === item?.id,
                        )?.name || "-"}
                      </td>
                    </tr>
                  ))}
                  {filteredTransactions?.length === 0 && (
                    <tr>
                      <td colSpan="7" className="text-center p-4 text-gray-500">
                        No transactions found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="section mt-10">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2 border-b-4 pb-2 border-green-500">
              Refund History
            </h2>

            <div className="overflow-auto rounded-lg shadow bg-white">
              <table className="min-w-full text-sm text-left">
                <thead className="bg-gray-200 text-black border border-2 shadow-lg">
                  <tr>
                    <th className="p-4">S.No</th>
                    <th className="p-4">Comments</th>
                    <th className="p-4">Type</th>
                    <th className="p-4">Added at</th>
                    <th className="p-4">Image</th>
                    <th className="p-4">Unit/Days/Count</th>
                    <th className="p-4 text-right">Amount</th>
                    <th className="p-4 text-right">Created by</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRefundTransactions?.map((txn) => (
                    <tr key={txn?.id} className="border-b hover:bg-gray-50">
                      <td className="p-4">
                        {txn?.id}
                        <br />
                      </td>
                      <td className="p-4">
                        <span>{txn?.comments}</span>
                      </td>
                      <td className="p-4">
                        {bookingRefunds[txn?.lineItemSubType]}
                        <br />
                      </td>
                      <td
                        className={`p-4 text-center font-semibold ${
                          txn.type === "charge"
                            ? "text-red-500"
                            : "text-green-600"
                        }`}
                      >
                        {formatDateAndTime(txn?.updatedAt)}
                      </td>
                      <td className="p-4">
                        <img
                          onClick={() => {
                            handleImageOpen(txn?.imageUrl);
                          }}
                          className="h-10 w-10 cursor-pointer"
                          alt="No Image"
                          src={txn?.imageUrl || "N/A"}
                        />
                      </td>
                      <td className="p-4">
                        {txn?.unitValue}
                        <br />
                      </td>
                      <td className="p-4">{txn?.amount}</td>
                      <td className="p-4">
                        {systemUserData?.find(
                          (item) => txn?.createdBy === item?.id,
                        )?.name || "-"}
                      </td>
                    </tr>
                  ))}
                  {filteredRefundTransactions?.length === 0 && (
                    <tr>
                      <td colSpan="7" className="text-center p-4 text-gray-500">
                        No transactions found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-1 gap-6 mt-4">
            <div className="overflow-x-auto">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2 border-b-4 pb-2 border-red-500">
                Billing Details
              </h2>
              <table className="w-full bg-white border-collapse text-md">
                <thead>
                  <tr className="bg-blue-100 text-gray-700">
                    <th className="p-2 text-left">Description</th>
                    <th className="p-2 text-left">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Weekday Rent Row */}
                  <tr className="border-b border-gray-200">
                    <td className="p-2 flex items-center space-x-1">
                      <span>Weekday Rent</span>
                      <small className="text-gray-500">
                        ({paymentDetailsData?.weekdayHrs || 0} Hrs)
                      </small>
                      <small className="text-gray-500">
                        (
                        {paymentDetailsData?.packageDetails?.weekdayTariff || 0}{" "}
                        / Hr)
                      </small>
                    </td>
                    <td className="p-2 text-blue-600 font-medium">
                      {"₹ " + paymentDetailsData?.weekdayRent || 0}
                    </td>
                  </tr>

                  {/* Weekend Rent Row */}
                  <tr className="border-b border-gray-200">
                    <td className="p-2 flex items-center space-x-1">
                      <span>Weekend Rent</span>
                      <small className="text-gray-500">
                        ({paymentDetailsData?.weekendHrs || 0} Hrs)
                      </small>
                      <small className="text-gray-500">
                        (
                        {paymentDetailsData?.packageDetails?.weekendTariff || 0}{" "}
                        / Hr)
                      </small>
                    </td>
                    <td className="p-2 text-blue-600 font-medium">
                      {"₹ " + paymentDetailsData?.weekendRent || 0}
                    </td>
                  </tr>

                  {/* Discount Amount Row */}
                  <tr className="border-b border-gray-200">
                    <td className="p-2 flex items-center space-x-1">
                      <span>Discount Amount</span>
                      <small className="text-gray-500">
                        ({paymentDetailsData?.discountPercentage || 0} %)
                      </small>
                    </td>
                    <td className="p-2 text-green-600 font-medium">
                      {"₹ " + paymentDetailsData?.discountAmount || 0}
                    </td>
                  </tr>

                  {/* Tax Amount Row */}
                  <tr className="border-b border-gray-200">
                    <td className="p-2">Tax</td>
                    <td className="p-2 text-red-600 font-medium">
                      {"₹ " + paymentDetailsData?.taxAmount || 0}
                    </td>
                  </tr>

                  {/* Security Deposit Row */}
                  <tr className="border-b border-gray-200">
                    <td className="p-2">Security Deposit</td>
                    <td className="p-2 text-blue-600 font-medium">
                      {"₹ " + paymentDetailsData?.securityDeposit || 0}
                    </td>
                  </tr>

                  {/* Pickup Charges Row */}
                  <tr className="border-b border-gray-200">
                    <td className="p-2">Pickup Charges</td>
                    <td className="p-2 text-blue-600 font-medium">
                      {"₹ " + paymentDetailsData?.pickupCharges || 0}
                    </td>
                  </tr>

                  {/* Delivery Charges Row */}
                  <tr className="border-b border-gray-200">
                    <td className="p-2">Delivery Charges</td>
                    <td className="p-2 text-blue-600 font-medium">
                      {"₹ " + paymentDetailsData?.deliveryCharges || 0}
                    </td>
                  </tr>
                  {/* Final Rent */}
                  <tr>
                    <td className="p-2">Rental</td>
                    <td className="p-2 text-red-600 font-medium">
                      {"₹ " +
                        (
                          paymentDetailsData?.weekdayRent +
                          paymentDetailsData?.weekendRent +
                          paymentDetailsData?.taxAmount +
                          paymentDetailsData?.securityDeposit +
                          paymentDetailsData?.pickupCharges +
                          paymentDetailsData?.deliveryCharges -
                          paymentDetailsData?.discountAmount
                        ).toFixed(2) || "Not Specified"}
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200">
                    <td className="p-2">Total Charges</td>
                    <td className="p-2 text-blue-600 font-medium">
                      {"₹ " + Math.round(refundDetails?.totalCharges)}
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200">
                    <td className="p-2">Total Refunds</td>
                    <td className="p-2 text-blue-600 font-medium">
                      {"₹ " + refundDetails?.totalRefunds}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="section mt-10">
            <div className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2 border-b-4 pb-2 border-yellow-500">
              Booking Costing Details
              <div class="relative inline-block group">
                <button class="relative px-6 py-3 text-sm font-semibold text-white bg-indigo-600/90 rounded-xl hover:bg-indigo-700/90 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-900 transition-all duration-300 overflow-hidden">
                  <div class="absolute inset-0 bg-gradient-to-r from-purple-500/20 to-pink-500/20 blur-xl group-hover:opacity-75 transition-opacity"></div>

                  <span class="relative flex items-center gap-2">
                    <svg
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      fill="none"
                      class="w-4 h-4"
                    >
                      <path
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        stroke-width="2"
                        stroke-linejoin="round"
                        stroke-linecap="round"
                      ></path>
                    </svg>
                  </span>
                </button>

                <div class="absolute invisible opacity-0 group-hover:visible group-hover:opacity-100 bottom-full left-1/2 -translate-x-1/2 mb-3 w-72 transition-all duration-300 ease-out transform group-hover:translate-y-0 translate-y-2">
                  <div class="relative p-4 bg-gradient-to-br from-gray-900/95 to-gray-800/95 backdrop-blur-md rounded-2xl border border-white/10 shadow-[0_0_30px_rgba(79,70,229,0.15)]">
                    <div class="flex items-center gap-3 mb-2">
                      <div class="flex items-center justify-center w-8 h-8 rounded-full bg-indigo-500/20">
                        <svg
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          class="w-4 h-4 text-indigo-400"
                        >
                          <path
                            clip-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                            fill-rule="evenodd"
                          ></path>
                        </svg>
                      </div>
                      <h3 class="text-sm font-semibold text-white">
                        Important Information
                      </h3>
                    </div>

                    <div class="space-y-2">
                      <p class="text-sm text-gray-300">
                        Pending amount is shown until the security deposit
                        refund is initiated. If the customer pays the pending
                        amount, the full security deposit will be refunded.
                      </p>
                    </div>

                    <div class="absolute inset-0 rounded-2xl bg-gradient-to-r from-indigo-500/10 to-purple-500/10 blur-xl opacity-50"></div>

                    <div class="absolute -bottom-1.5 left-1/2 -translate-x-1/2 w-3 h-3 bg-gradient-to-br from-gray-900/95 to-gray-800/95 rotate-45 border-r border-b border-white/10"></div>
                  </div>
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="overflow-auto rounded-lg shadow bg-white">
              <table className="min-w-full text-sm text-left">
                <thead className="bg-gray-200 text-black border border-2 shadow-lg">
                  <tr>
                    <th className="p-2">Security Deposit</th>
                    <th className="p-2">Total of Charges</th>
                    <th className="p-2">Total of Refunds</th>
                    <th className="p-2">Total Amount Paid</th>
                    <th className="p-2 flex">Pending Amount </th>
                    <th className="p-2">Recovery Amount</th>
                    <th className="p-2">Refundable Amount</th>
                    {/* {refundDetails?.recoveryAmount > 0 ? (
                      <></>
                    ) : Number(fleetBookingStatus?.inverted?.refundPending) ===
                      summaryDetails?.bookingStatus ? (
                      <></>
                    ) : (
                      <th className="p-2 text-right">Action</th>
                    )} */}
                  </tr>
                </thead>
                {refundDetails && (
                  <tbody>
                    {refundDetails ? (
                      <tr className="border-b hover:bg-gray-50">
                        <td className="p-2">
                          {"₹ " + refundDetails?.securityDeposit}
                        </td>
                        <td className="p-2 text-red-500 font-semibold">
                          {"₹ " + Math.round(refundDetails?.totalCharges)}
                        </td>
                        <td className="p-2 text-green-600 font-semibold">
                          {"₹ " + refundDetails?.totalRefunds}
                        </td>
                        <td className="p-2 text-green-600 font-semibold">
                          {"₹ " +
                            Number(
                              (refundDetails?.totalAmountPaid || 0).toFixed(2),
                            )}
                        </td>
                        <td className="p-2 text-center font-semibold">
                          {"₹ " + Math.round(refundDetails?.pendingAmount)}
                        </td>
                        <td className="p-2 text-center font-semibold">
                          {"₹ " + Math.round(refundDetails?.recoveryAmount)}
                        </td>
                        <td className="p-2 text-center font-semibold">
                          {"₹ " +
                            Number(
                              (refundDetails?.refundableAmount || 0).toFixed(2),
                            )}
                        </td>
                        {/* {refundDetails?.recoveryAmount > 0 ? (
                          <></>
                        ) : Number(
                            fleetBookingStatus?.inverted?.refundPending
                          ) === summaryDetails?.bookingStatus ? (
                          <></>
                        ) : (
                          <td className="p-2 text-right">
                            <button
                              onClick={() =>
                                handleInitiateRefund(
                                  refundDetails?.refundableAmount
                                )
                              }
                              className="w-32 h-12 bg-blue-400 rounded-full"
                            >
                              Initiate Refund
                            </button>
                          </td>
                        )} */}
                      </tr>
                    ) : (
                      <tr>
                        <td
                          colSpan="6"
                          className="text-center p-4 text-gray-500"
                        >
                          No transactions found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}
              </table>

              <div className="flex justify-end">
                {refundDetails?.recoveryAmount > 0 ? (
                  <p className="text-red-700 text-lg font-semibold w-full text-end">
                    The recovery amount or pending amount is still outstanding
                    and cannot be initiated.
                  </p>
                ) : Number(fleetBookingStatus?.inverted?.refundPending) ===
                  summaryDetails?.bookingStatus ? (
                  <div className="p-2">
                    <button
                      onClick={() => setIsChecklistModalOpen(true)}
                      className="w-44 h-12 bg-blue-400 text-white font-semibold rounded-full shadow hover:bg-blue-500 transition-colors flex items-center justify-center"
                    >
                      View Refund Checklist
                    </button>
                  </div>
                ) : Number(fleetBookingStatus?.inverted?.bookingClosed) ===
                  summaryDetails?.bookingStatus ? (
                  <div className="p-2">
                    <button
                      onClick={() => setIsChecklistModalOpen(true)}
                      className="w-44 h-12 bg-blue-400 text-white font-semibold rounded-full shadow hover:bg-blue-500 transition-colors flex items-center justify-center"
                    >
                      View Refund Checklist
                    </button>
                  </div>
                ) : (
                  <div className="p-2">
                    {actionsToAccess?.includes("Initiate Refund") && (
                      <button
                        // disabled={submittingRefund}
                        onClick={() => {
                          setIsChecklistModalOpen(true);
                          // handleInitiateRefund(refundDetails?.refundableAmount);
                        }}
                        className={`w-32 h-12 bg-blue-400 text-white font-semibold rounded-full shadow hover:bg-blue-500 transition-colors flex items-center justify-center`}
                      >
                        Initiate Refund
                      </button>
                    )}
                  </div>
                )}
              </div>

              {refundDetails?.recoveryAmount > 0 ? (
                <p className="text-red-700 text-lg font-semibold w-full text-end">
                  The recovery amount or pending amount is still outstanding and
                  cannot be initiated.
                </p>
              ) : refundDetails?.recoveryAmount === 0 ? (
                <></>
              ) : (
                <p className="text-red-700 text-lg font-semibold w-full text-end">
                  Recovery amount is in negative cannot able to initiate
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Bookinglineitems;
